<div class="json-box">
  <pre [innerHTML]="formattedJson"></pre>
</div>